"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packMessageAndMentions = void 0;
var CommentTypes_1 = require("@CommonFrontendBackend/Comments/Types/CommentTypes");
var GetReactMentionsFormat_1 = require("./GetReactMentionsFormat");
var lodash_1 = __importDefault(require("lodash"));
var packMessageAndMentions = function (message, mentions) {
    var mentionsSorted = lodash_1.default.orderBy(mentions, function (mention) { return mention.index; }, ["desc"]);
    var newMessage = message;
    var mentionsIntermediate = mentionsSorted.map(function (mention) {
        var mentionToExport = convertMentionItemToMention(mention);
        var displayWithoutMarker = mention.display.substring(1);
        var formattedMention = (0, GetReactMentionsFormat_1.getReactMentionsFormat)(displayWithoutMarker, mention.id);
        var prefixOfMessage = newMessage.substring(0, mention.index);
        var suffixOfMessage = newMessage.substring(mention.index + formattedMention.length);
        newMessage = prefixOfMessage + suffixOfMessage;
        var reverseIdx = suffixOfMessage.length;
        return {
            mentionToExport: mentionToExport,
            reverseIdx: reverseIdx,
        };
    });
    var mentionsEnrichedWithIndex = mentionsIntermediate.map(function (_a) {
        var mentionToExport = _a.mentionToExport, reverseIdx = _a.reverseIdx;
        mentionToExport.location = newMessage.length - reverseIdx;
        return mentionToExport;
    });
    return {
        message: newMessage,
        mentions: mentionsEnrichedWithIndex,
    };
};
exports.packMessageAndMentions = packMessageAndMentions;
var convertMentionItemToMention = function (mentionItem) {
    return {
        userId: mentionItem.id,
        type: CommentTypes_1.MentionType.Internal,
        location: -1,
    };
};
